import { render, staticRenderFns } from "./addClueDialog.vue?vue&type=template&id=85579888&scoped=true"
import script from "./addClueDialog.vue?vue&type=script&lang=js"
export * from "./addClueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85579888",
  null
  
)

export default component.exports